export function getUnreadNotifications (state) {
  if (!state.notifications) {
    return 0
  }

  return state.notifications.notifications.reduce((count, notification) => {
    return notification.status === 'unread' ? count + 1 : count
  }, 0)
}
